import React from "react";
import { useTranslation } from "react-i18next";
import { RenderElementProps, useSlateStatic } from "slate-react";

import { HeadingOne, HeadingTwo, HeadingThree, Citation, Image } from "./renderer";
import { CodeElement } from "./types";
import CodeMirrorEditor from "../codemirror/CodeMirrorEditor";

export const RichTextElement = ({ attributes, children, element }: RenderElementProps) => {
    const [t] = useTranslation();
    const editor = useSlateStatic();

    switch (element.type) {
        case "heading-one":
            return <HeadingOne {...attributes}>{children}</HeadingOne>;
        case "heading-two":
            return <HeadingTwo {...attributes}>{children}</HeadingTwo>;
        case "heading-three":
            return <HeadingThree {...attributes}>{children}</HeadingThree>;
        case "heading-four":
            return <h4 {...attributes}>{children}</h4>;
        case "heading-five":
            return <h5 {...attributes}>{children}</h5>;
        case "heading-six":
            return <h6 {...attributes}>{children}</h6>;
        case "block-quote":
        case "citation":
            return <Citation {...attributes}>{children}</Citation>;
        case "bulleted-list":
            return <ul {...attributes}>{children}</ul>;
        case "numbered-list":
            return <ol {...attributes}>{children}</ol>;
        case "list-item":
            return <li {...attributes}>{children}</li>;
        case "image":
            return (
                <Image
                    {...attributes}
                    src={element.url}
                    alt={t("inputs.RichText.imageAlt")}
                    isReadOnly={false}
                    element={element}
                    editor={editor}
                    title={t("inputs.RichText.clickToModifyUrl")}
                    className="cursor-pointer transition-opacity duration-200"
                >
                    {children}
                </Image>
            );
        case "code":
            const { ref, ...filteredAttributes } = attributes as any;
            return (
                <CodeMirrorEditor attributes={filteredAttributes} element={element as CodeElement}>
                    {children}
                </CodeMirrorEditor>
            );
        default:
            return (
                <p {...attributes} data-element-kind={element.type} className="my-4">
                    {children}
                </p>
            );
    }
};

export default RichTextElement;
